import moment from "moment";

const formatPracticeTestDateTime = (time) => {
  if (!time) return "";

  let epochTime = time;
  if (epochTime.toString().length === 10) {
    epochTime = epochTime * 1000;
  }

  return moment(epochTime)
    .format("YYYY/MM/DD, hh:mm A")
    .replace(/(AM|PM)$/, (match) => match.charAt(0) + match.slice(1).toLowerCase());
};

export const formatPracticeTestTimeRange = (startTime="", endTime="") => {
  const formattedStart = formatPracticeTestDateTime(startTime);
  const formattedEnd = formatPracticeTestDateTime(endTime);

  if (!formattedStart && !formattedEnd) return "";
  if (!formattedEnd) return formattedStart;
  if (!formattedStart) return formattedEnd;

  if(startTime){
    return formattedStart;
  }
  if(endTime){
    return formattedEnd;
  }
  return `${formattedStart} - ${formattedEnd}`;
};

export default formatPracticeTestDateTime;
